import { SearchIcon, CrossIcon } from 'assets/svg';
import React, { ChangeEvent, useState, useCallback, useEffect } from 'react';

type Props = React.HTMLProps<HTMLInputElement> & {
  prefix?: string;
  initValue?: string;
  onUpdate?: (v: string) => void;
  onClear?: () => void;
};

function TextInput({ prefix, placeholder, initValue, onUpdate, onClear, ...props }: Props) {
  const [value, setValue] = useState(initValue || '');
  const onChangeCallback = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onUpdate?.(e.target.value);
    },
    [setValue, onUpdate]
  );

  useEffect(() => setValue(initValue || ''), [initValue]);

  return (
    <div className="relative bg-white w-full h-11 flex items-center border rounded-full border-palette-color-border pl-9 pr-8 py-2">
      {prefix && <span className="shrink-0 font-semibold text-sm mr-2">{`${prefix}:`}</span>}
      <input
        type="text"
        className="bg-transparent border-0 p-0 focus:ring-0 text-sm w-full flex-1"
        value={value}
        placeholder={placeholder || ''}
        aria-label={props['aria-label'] || placeholder}
        onChange={onChangeCallback}
      />
      <div className="absolute cursor-pointer group left-3 inset-y-0 flex items-center" onClick={onClear}>
        <SearchIcon className="w-4 h-4" />
      </div>
      {value && onClear && (
        <div
          role="button"
          aria-label="Clear search"
          className="absolute cursor-pointer group right-3 inset-y-0 flex items-center"
          onClick={onClear}
        >
          <CrossIcon className="transition-transform group-hover:scale-125 w-3 h-3" />
        </div>
      )}
    </div>
  );
}

export default TextInput;
